import { render } from "./StockTicker.vue?vue&type=template&id=5dbfc422"
import script from "./StockTicker.vue?vue&type=script&lang=js"
export * from "./StockTicker.vue?vue&type=script&lang=js"

import "./StockTicker.vue?vue&type=style&index=0&id=5dbfc422&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__